import * as React from "react";
const SvgSpeichern = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="Speichern">
    <path
      fill="currentColor"
      d="M180 28.24a9.12 9.12 0 0 0-6.45-2.67H34.69c-5.04 0-9.12 4.08-9.12 9.12V221.3c0 5.04 4.08 9.12 9.12 9.12H221.3c5.04 0 9.12-4.08 9.12-9.12V82.46c0-2.42-.96-4.74-2.67-6.45l-47.76-47.76Zm-27.39 12.33v55.21H135.5V40.57zm-32.11 0v55.21H83.45V40.57zM83.45 215.43v-55.21h89.1v55.21zm131.98 0h-27.88v-63.29c0-3.82-3.1-6.92-6.92-6.92H75.38c-3.82 0-6.92 3.1-6.92 6.92v63.29H40.58V40.57h27.88v63.29c0 3.82 3.1 6.92 6.92 6.92h85.31c3.82 0 6.92-3.1 6.92-6.92V40.57h3.5l44.32 44.32z"
    />
  </svg>
);
export default SvgSpeichern;
